<div class="choose-language-container h-100">
    <div class="d-flex flex-wrap justify-content-center gap-3 align-items-center">
        <button class="language-box" *ngFor="let language of languages; let indexLanguage = index"
            [disabled]="language.isDefault" (click)="redirectLanguageDetail(language)">
            <span class="fw-bold">{{language.name}} - {{language.code}}</span>
            <!-- [ngStyle]="{background: 'url(../assets/img/country-flags/language-flags/language-' + language.code + '.svg' + ') no-repeat center'}" -->
        </button>
    </div>
</div>